import { useEffect } from "react";

import { useGlobal } from "../globalContext";

// DO NOT use this hook directly in components or other hooks
// this is an internal hook that should be only used by JoinedMeetingScreenIOContextProvider, to provide centralized state management and logic control
export default function useCentralLogicsMouse({
  // context managed states and methods
  userHasMouse,
  sendMouseCommand,
  setMouseIconState,
}) {
  const { VIDEO_MAIN } = useGlobal();

  useEffect(() => {
    if (!VIDEO_MAIN.current) return;

    // Disable RightClick Menu on Canvas
    VIDEO_MAIN.current.oncontextmenu = (e) => {
      e.preventDefault();
    };

    // const screen = SCREEN_STATE.screens.find((x) => x.id === SCREEN_STATE.currentScreen.id);
    // if (!screen || !screen.io_m_res) return;
    // const [screenWidth, screenHeight] = screen.io_m_res;

    if (userHasMouse) {
      let holdActive = false; // This flag indicates the user is currently holding the mouse down
      let isDragging = false;
      let btnActive = 0;

      VIDEO_MAIN.current.onmousedown = function (e) {
        holdActive = true;
        btnActive = e.button;
      };

      VIDEO_MAIN.current.onmouseup = function (e) {
        if (isDragging) {
          console.log("Dragging, so now releasing...");
          switch (btnActive) {
            case 0:
              sendMouseCommand("btn 6");
              break;
            case 2:
              sendMouseCommand("btn 7");
              break;
            default:
              return;
          }
        } else {
          console.log("not dragging");
          switch (btnActive) {
            case 0:
              // left click
              console.log("btn 0 ");
              sendMouseCommand("btn 0");
              setMouseIconState("left-click");
              break;
            case 2:
              // right click
              console.log("btn 1");
              sendMouseCommand("btn 1");
              setMouseIconState("right-click");
              break;
            default:
              return;
          }
        }

        holdActive = false;
        isDragging = false;
      };

      VIDEO_MAIN.current.onwheel = function (e) {
        if (e.deltaY < 0) {
          console.log("scrolling up");
          sendMouseCommand("btn 9");
        } else if (e.deltaY > 0) {
          console.log("scrolling down");
          sendMouseCommand("btn 10");
        }
      };

      VIDEO_MAIN.current.onmousemove = function (e) {
        if (holdActive) {
          console.log("pressing hold");
          isDragging = true;
          switch (btnActive) {
            case 0:
              sendMouseCommand("btn 3");
              break;
            case 2:
              sendMouseCommand("btn 4");
              break;
            default:
              return;
          }
          holdActive = false;
        }

        // Retrieve the dimensions of the <video> element
        const { left, top, width, height } = VIDEO_MAIN.current.getBoundingClientRect();
        const videoElement = VIDEO_MAIN.current;

        const scaleX = videoElement.videoWidth / width;
        const scaleY = videoElement.videoHeight / height;

        const localX = e.clientX - left;
        const localY = e.clientY - top;

        const x = Math.round(localX * scaleX);
        const y = Math.round(localY * scaleY);

        const designScaleX = videoElement.videoWidth / 1024;
        const designScaleY = videoElement.videoHeight / 768;

        sendMouseCommand(`abs ${x / designScaleX} ${y / designScaleY} 1`);
      };
    } else {
      const noOp = () => {};
      VIDEO_MAIN.current.onmousedown = noOp;
      VIDEO_MAIN.current.onmouseup = noOp;
      VIDEO_MAIN.current.onwheel = noOp;
      VIDEO_MAIN.current.onmousemove = noOp;
    }
  }, [VIDEO_MAIN.current, userHasMouse, sendMouseCommand, setMouseIconState]);
}
